import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import account from './modules/account';
import broadCast from './modules/broadCast';
import callInfo from './modules/callInfo';
import report from './modules/report';
import loginAbnormal from './modules/loginAbnormal';
import exportTips from './modules/exportTips';
import menu from './modules/menu';
const debug = process.env.NODE_ENV !== 'production';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    user,
    account,
    broadCast,
    callInfo,
    report,
    loginAbnormal,
    exportTips,
    menu
  },
  strict: debug
});



// WEBPACK FOOTER //
// ./src/store/index.js